import { OTPInputComponent } from "../../Login/LoginComp";
import { AuthenticationSchema } from "../../../Utils/formOptions";
import {
  deploymentTypes,
  selected_authentication_server,
  servers,
  serverType,
} from "../../../deployment-config";
import { useState } from "react";
import { useForm } from "react-hook-form";
import PopupWrapper from "../../../components/PopupWrapper";
import FormBox from "../../../components/FormBox/FormBox";
import { LoadingButton } from "../../../Utils/CustomComponent";
import axios from "../../../axios";
import urls from "../../../Utils/urls";

let server_address =
  serverType === deploymentTypes.development
    ? servers.development
    : deploymentTypes.localDevelopment
    ? servers.localDevelopment
    : servers.production;

const environment_hostname = `https://${server_address}/api/v1`;

const AuthenticationPopup = ({
  otpPopup,
  setOtpPopup,
  setIsAuthenticated,
  show5pmMessage = true,
}) => {
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [otpEntered, setOtpEntered] = useState("");
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableFWS, setDisableFWS] = useState(false);
  const [otpReceived, setOtpReceived] = useState("");
  const user = localStorage.getItem("accessed_user");

  const defaultValues = {
    email: JSON.parse(user)?.email,
  };
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues, ...AuthenticationSchema });
  const watchValue = watch();

  const handleInitialLogin = async (email, password) => {
    setDisableFWS(true);
    try {
      const res = await axios.post(
        `${environment_hostname}/auth/get_auth_token`,
        {
          username: email,
          password: password,
        }
      );

      // const decodedOtp = atob(res.data.otp); // Decode OTP
      // console.log(decodedOtp);
      // setOtpReceived(decodedOtp);

      setShowOtpInput(true);
      setIsOtpStage(true);
      setPromptFail(null);
    } catch (error) {
      console.error("Login failed:", error);
      setPromptFail("Invalid email and/or password. Please try again.");
      setDisableFWS(false);
    }
  };

  const onSubmit = async (data) => {
    localStorage.setItem("email_for_forgot_password", data.email);
    setDisableFWS(true);
    if (isOtpStage) {
      if (otpEntered?.length === 6) {
        try {
          setAfterOtpLoading(true);
          // first API call to validate OTP
          const data2 = {
            UserName: data.email,
            otp: otpEntered,
          };
          const res3 = await axios.post(
            urls.admin.validateLoginOTP,
            data2,
            selected_authentication_server.access_account.headers
          );

          if (res3.status == 200) {
            // Second API call if OTP is correct
            const res2 = await axios.post(
              selected_authentication_server.access_account.endpoint,
              { userid: localStorage.getItem("apex_userid") },
              selected_authentication_server.access_account.headers
            );
            if (res2.status == "200") {
              setIsAuthenticated(true);
              handleClose();
            }
          }
        } catch (error) {
          console.error("Failed to verify user:", error);
          setPromptFail("Failed to verify OTP. Please try again.");
        }
      } else {
        setPromptFail("Please enter a 6 digit valid OTP!");
      }
      setAfterOtpLoading(false);
    } else {
      handleInitialLogin(data.email, data.password);
    }
  };

  function handleClose() {
    setOtpPopup(false);
    setShowOtpInput(false);
    setPromptFail(null);
    setOtpEntered("");
    setIsOtpStage(false);
    setAfterOtpLoading(false);
    setDisableFWS(false);
    setOtpReceived("");
    setValue("password", "");
  }

  function isAfterFivePM() {
    const currentTime = new Date(); // Get the current date and time
    const currentHour = currentTime.getHours(); // Extract the current hour (0-23)

    // Check if the current hour is 17 (5 PM) or later
    return currentHour >= 17 && show5pmMessage;
  }

  return (
    <div>
      <PopupWrapper
        title="Authentication"
        extraClass="width-800"
        Component={
          <div>
            <form>
              <FormBox
                options={authArr(isAfterFivePM)}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />

              <div className="form-outline mb-1">
                {showOtpInput && (
                  <>
                    <OTPInputComponent
                      setOtpEntered={setOtpEntered}
                      setOtpReceived={setOtpReceived}
                      onClick={() =>
                        handleInitialLogin(
                          watchValue?.email,
                          watchValue?.password
                        )
                      }
                    />
                  </>
                )}
              </div>

              <div className="text-center pt-1 mt-5 mb-5 pb-1">
                {showOtpInput ? (
                  <LoadingButton
                    className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                    title={"Verify OTP and Continue"}
                    disabled={afterOtpLoading}
                    loading={afterOtpLoading}
                  />
                ) : (
                  <LoadingButton
                    className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                    disabled={disableFWS}
                    loading={disableFWS}
                    title={"Continue"}
                  />
                )}

                {promptFail && (
                  <div className="alert alert-error" role="alert">
                    {promptFail}
                  </div>
                )}
                <br />
              </div>
            </form>
          </div>
        }
        toShow={otpPopup}
        closeEventHandler={handleClose}
      />
    </div>
  );
};

export default AuthenticationPopup;

const authArr = (isAfterFivePM) => {
  const res = isAfterFivePM();
  return [
    {
      content: (
        <h5>
          *Note: All payments made after hours/weekends/holidays will be process
          the following business day.
        </h5>
      ),
      type: "content",
      className: "col-12",
      display: `${res ? "" : "hidden"}`,
    },
    {
      title: "Email",
      field: "email",
      type: "email",
      className: "col-12",
      disable: true,
    },
    {
      title: "Password",
      field: "password",
      type: "password",
      className: "col-12",
    },
  ];
};
